<div class="left-menu-container full" [@show]="!invisible && state">
  <ng-container *ngIf="!invisible && (state || !closed)" [ngTemplateOutlet]="full"></ng-container>
</div>

<div class="left-menu-container rail" *ngIf="!isH5" [@show]="!invisible && !state">
  <ng-container *ngIf="!invisible && (!state || !opened)" [ngTemplateOutlet]="rail"></ng-container>
</div>

<ng-template #full>
  <div class="menu-head">
    <div
      class="trigger animate__animated animate__faster animate__fadeIn animate__fill_none"
      *ngIf="!isH5"
      (click)="turn(false)"
    >
      <i class="trigger-icon icon-bottom-menu"></i>
    </div>
    <app-logo
      [lockDevice]="'web'"
      [onlineSize]="['auto', '24']"
      [onlineSizeH5]="['auto', '24']"
      [sitSize]="['116', '24']"
      [sitSizeH5]="['97', '24']"
      [clickable]="true"
    ></app-logo>

    <div class="h5-menu-head" *ngIf="isH5">
      <a [href]="domain + '/' + appService.languageCode" (click)="$event.preventDefault()">
        <customize-button
          type="text"
          [icon]="menuData.home.icon"
          radius=".8rem"
          (onClick)="turn(false); router.navigateByUrl(menuData.home.page)"
        >
          <span>{{ menuData.home.name }}</span>
        </customize-button>
      </a>
      <i class="icon-close-simple" (click)="turn(false)"></i>
    </div>
  </div>

  <!-- web -->
  <div class="menu-body" *ngIf="!isH5">
    <app-scrollbar #scrollbar>
      <!-- 活动入口 -->
      <app-left-menu-activity-bar
        (afterClick)="turn(false)"
        [showFully]="true"
        [showRail]="false"
        [showInviteCodeModel]="isShowInviteCodeModel"
      ></app-left-menu-activity-bar>

      <ng-container *ngTemplateOutlet="leftExpandMenu"></ng-container>
    </app-scrollbar>
  </div>

  <app-scrollbar *ngIf="isH5">
    <!-- h5 -->
    <app-left-menu-activity-bar
      (afterClick)="turn(false)"
      [showFully]="true"
      [showRail]="false"
      [showInviteCodeModel]="isShowInviteCodeModel"
    ></app-left-menu-activity-bar>
    <div class="menu-body">
      <ng-container *ngTemplateOutlet="leftExpandMenu"></ng-container>
    </div>
  </app-scrollbar>
</ng-template>

<ng-template #rail>
  <div class="menu-head">
    <div
      class="trigger animate__animated animate__faster animate__fadeIn animate__fill_none"
      *ngIf="closed"
      (click)="turn(true)"
    >
      <i class="trigger-icon icon-bottom-menu"></i>
    </div>
  </div>

  <!-- 轨道活动入口 -->
  <app-left-menu-activity-bar
    (afterClick)="isH5 && turn(false)"
    [showFully]="false"
    [showRail]="true"
  ></app-left-menu-activity-bar>

  <div class="menu-body">
    <!-- 頂部 -->
    <div class="rail-menu-list">
      <ng-container *ngFor="let item of menuData.top">
        <ng-container
          [ngTemplateOutlet]="menuListTemplate"
          [ngTemplateOutletContext]="{
            item: item,
            icon: item.icon,
            mouesEnterFn: onMouseEnter,
            mouseLeaveFn: onMouseLeave,
          }"
        ></ng-container>
      </ng-container>
    </div>

    <!-- 小游戏 -->
    <div class="rail-menu-list">
      <ng-container *ngFor="let item of menuData.list">
        <ng-container *ngIf="item.children?.length && item.canShowDropDown; else railDirectItem">
          <div class="rail-menu-accordion" [class.expanded]="item.expand">
            <div
              class="rail-trigger"
              [class.disabled]="checkDisabled(item)"
              (mouseenter)="onMouseEnter(item)"
              (mouseleave)="onMouseLeave(item)"
              (click)="$event.stopPropagation(); clickMenu(item, true); item && (item.tooltip = false); $event.preventDefault()"
              cdkOverlayOrigin
              #origin="cdkOverlayOrigin"
            >
              <div class="rail-menu-item">
                <ng-container *ngIf="isLeftMenuReady">
                  <div class="rail-menu-icon-container" [class.active]="isRouteActive(item?.railPage)">
                    <ng-container *ngIf="item?.railIcon?.startsWith('http'); else parentIconClassTemp">
                      <img class="rail-menu-image" [src]="item.railColorIcon || item.railIcon" lazy="loading" />
                    </ng-container>
                    <ng-template #parentIconClassTemp>
                      <i class="rail-menu-icon" [class]="item.railIcon"></i>
                    </ng-template>
                  </div>
                </ng-container>
                <ng-container *ngIf="!isLeftMenuReady">
                  <div class="rail-skeleton skeleton-loading"></div>
                </ng-container>
              </div>
            </div>
            <ng-template
              cdkConnectedOverlay
              [cdkConnectedOverlayOrigin]="origin"
              [cdkConnectedOverlayPositions]="railPositions"
              [cdkConnectedOverlayOpen]="item.tooltip && !item.expand"
            >
              <div class="rail-tooltip">
                {{ item?.name || '' }}
              </div>
            </ng-template>

            <div class="rail-submenu-group" *ngIf="item.expand">
              <ng-container *ngFor="let child of item.children">
                <a
                  class="rail-trigger"
                  [class.disabled]="checkDisabled(child)"
                  [routerLink]="getRouterLink(child?.page || null)"
                  [href]="domain + getRouterLink(child?.page || null)"
                  (click)="$event.stopPropagation(); clickMenu(child); child && (child.tooltip = false); $event.preventDefault()"
                  (mouseenter)="onMouseEnter(child)"
                  (mouseleave)="onMouseLeave(child)"
                  cdkOverlayOrigin
                  #subOrigin="cdkOverlayOrigin"
                >
                  <div class="rail-menu-item rail-submenu-item">
                    <div class="rail-menu-icon-container" [class.active]="isRouteActive(child?.page)">
                      <ng-container *ngIf="child?.menuIcon?.startsWith('http'); else childIconClassTemp">
                        <img class="rail-menu-image" [src]="child.menuIcon" lazy="loading" />
                      </ng-container>
                      <ng-template #childIconClassTemp>
                        <i class="rail-menu-icon" [class]="child.icon"></i>
                      </ng-template>
                    </div>
                  </div>
                </a>
                <ng-template
                  cdkConnectedOverlay
                  [cdkConnectedOverlayOrigin]="subOrigin"
                  [cdkConnectedOverlayPositions]="railPositions"
                  [cdkConnectedOverlayOpen]="child.tooltip && !checkDisabled(child)"
                >
                  <div class="rail-tooltip">
                    {{ child?.name || '' }}
                  </div>
                </ng-template>
              </ng-container>
            </div>
          </div>
        </ng-container>
        <ng-template #railDirectItem>
          <ng-container
            [ngTemplateOutlet]="menuListTemplate"
            [ngTemplateOutletContext]="{
              item: item,
              icon: item.railIcon,
              mouesEnterFn: onMouseEnter,
              mouseLeaveFn: onMouseLeave,
            }"
          ></ng-container>
        </ng-template>
      </ng-container>
    </div>

    <!-- 优惠活动； vip ；代理；帮助中心 -->
    <div class="rail-menu-list">
      <ng-container *ngFor="let item of menuData.options">
        <ng-container
          [ngTemplateOutlet]="menuListTemplate"
          [ngTemplateOutletContext]="{
            item: item,
            icon: item.icon,
            mouesEnterFn: onMouseEnter,
            mouseLeaveFn: onMouseLeave,
          }"
        ></ng-container>
      </ng-container>
    </div>

    <!-- 推荐ID -->
    <div class="rail-menu-list" *ngIf="showBindReferralId">
      <ng-container *ngFor="let item of menuData.referralId">
        <div
          *ngIf="item.showOnRail"
          class="rail-menu-item"
          (click)="openReferralId()"
          (mouseenter)="item.tooltip = true"
          (mouseleave)="item.tooltip = false"
          cdkOverlayOrigin
          #origin="cdkOverlayOrigin"
        >
          <div class="rail-menu-icon-container" *ngIf="item.showOnRail" [class.active-hover]="item.tooltip">
            <img class="rail-menu-image" [src]="item.image" alt="" />
          </div>
        </div>
      </ng-container>
    </div>

    <ng-container *ngIf="logined">
      <!-- 轨道活动入口 -->
      <app-left-menu-activity-bar
        (afterClick)="isH5 && turn(false)"
        [showFully]="false"
        [showRail]="true"
        [onlyShowInvite]="true"
      ></app-left-menu-activity-bar>
    </ng-container>

    <!-- 赞助 和 客服 -->
    <div class="rail-menu-list">
      <ng-container *ngFor="let item of menuData.supports">
        <ng-container
          *ngIf="item.ident === 'chat' ? chatService.chatEnabled : true"
          [ngTemplateOutlet]="menuListTemplate"
          [ngTemplateOutletContext]="{
            item: item,
            icon: item.icon,
            mouesEnterFn: onMouseEnter,
            mouseLeaveFn: onMouseLeave,
          }"
        ></ng-container>
      </ng-container>
    </div>

    <!-- 语言；主题；默认货币 -->
    <div class="rail-menu-list">
      <ng-container *ngFor="let item of menuData.systems; let index = index">
        <ng-container *ngIf="item.ident !== 'themeSelect'">
          <div
            *ngIf="item.showOnRail"
            class="rail-menu-item"
            (click)="onSetSystem(index)"
            (mouseenter)="item.tooltip = true"
            (mouseleave)="item.tooltip = false"
            cdkOverlayOrigin
            #origin="cdkOverlayOrigin"
          >
            <div
              class="rail-menu-icon-container"
              *ngIf="item.showOnRail && isLeftMenuReady"
              [class.active-hover]="item.tooltip"
            >
              <span class="rail-menu-text"> {{ item.name }}</span>
            </div>
            <ng-container *ngIf="!isLeftMenuReady">
              <div class="rail-skeleton skeleton-loading"></div>
            </ng-container>
            <ng-template
              cdkConnectedOverlay
              [cdkConnectedOverlayOrigin]="origin"
              [cdkConnectedOverlayPositions]="popupPosition"
              [cdkConnectedOverlayOpen]="leftMenuService.popupStatus && index === 0"
            >
              <ng-container [ngTemplateOutlet]="langCurrencyPupup"></ng-container>
            </ng-template>
          </div>
        </ng-container>

        <ng-container *ngIf="item.ident === 'themeSelect'">
          <div
            class="rail-menu-item"
            cdkOverlayOrigin
            #origin="cdkOverlayOrigin"
            (mouseenter)="onShowSubItem(item)"
            (mouseleave)="onCloseSubItem(150, item)"
          >
            <div class="rail-menu-icon-container" [class.active-hover]="item.tooltip">
              <i class="rail-menu-icon" [class]="'icon-' + appService.themeSwitch$.value"></i>
            </div>
          </div>
          <ng-template
            cdkConnectedOverlay
            [cdkConnectedOverlayOrigin]="origin"
            [cdkConnectedOverlayPositions]="themePositions"
            [cdkConnectedOverlayOpen]="item.tooltip && !isH5"
          >
            <ng-container
              [ngTemplateOutlet]="themeSwitch"
              [ngTemplateOutletContext]="{
                theme: appService.themeSwitch$ | async,
                item: item,
                height: '4rem',
                class: 'cover-item',
              }"
            ></ng-container>
          </ng-template>
        </ng-container>
      </ng-container>
    </div>
  </div>
</ng-template>

<!-- rail menu list template -->
<ng-template
  #menuListTemplate
  let-item="item"
  let-tooltip="tooltip"
  let-icon="icon"
  let-mouesEnterFn="mouesEnterFn"
  let-mouseLeaveFn="mouseLeaveFn"
>
  <ng-container *ngIf="!checkDisabled(item)">
    <a
      [href]="domain + getRouterLink(item?.railPage || item?.page || null)"
      [routerLink]="getRouterLink(item?.railPage || item?.page || null)"
      (click)="$event.stopPropagation(); clickMenu(item); item && (item.tooltip = false); $event.preventDefault()"
      (mouseenter)="mouesEnterFn(item)"
      (mouseleave)="mouseLeaveFn(item)"
      [class.disabled]="checkDisabled(item)"
    >
      <div class="rail-menu-item" cdkOverlayOrigin #origin="cdkOverlayOrigin">
        <ng-container *ngIf="isLeftMenuReady">
          <div
            class="rail-menu-icon-container"
            [class.active]="isRouteActive(item?.railPage) || isRouteActive(item?.page)"
          >
            <ng-container *ngIf="icon?.startsWith('http'); else iconClassTemp">
              <!-- <img
            class="rail-menu-image"
            [src]="icon"
            lazy="loading"
            [style.display]="!isRouteActive(item?.railPage) ? 'block' : 'none'"
          /> -->
              <img
                class="rail-menu-image"
                [src]="item?.railColorIcon"
                lazy="loading"
                [class.filter-img]="isRouteActive(item?.railPage) || isRouteActive(item?.page)"
              />
            </ng-container>
            <ng-template #iconClassTemp>
              <i
                [class]="'rail-menu-icon' + ' ' + icon"
                [ngClass]="{
                  'show-dot':
                    (icon === 'icon-menu-promotion' && activityCount > 0) ||
                    (icon === 'icon-chat-vip' && chatService.chatEnabled && chatService.unreadCount > 0),
                }"
              ></i>
            </ng-template>
          </div>
        </ng-container>
        <ng-container *ngIf="!isLeftMenuReady">
          <div class="rail-skeleton skeleton-loading"></div>
        </ng-container>
      </div>
    </a>
    <ng-template
      cdkConnectedOverlay
      [cdkConnectedOverlayOrigin]="origin"
      [cdkConnectedOverlayPositions]="railPositions"
      [cdkConnectedOverlayOpen]="item.tooltip"
    >
      <div class="rail-tooltip">
        {{ item?.name || '' }}
      </div>
    </ng-template>
  </ng-container>
</ng-template>

<!-- theme 切换 -->
<ng-template #themeSwitch let-theme="theme" let-item="item" let-height="height" let-class="class">
  <div
    class="theme-container"
    [class]="class"
    [style.height]="height"
    (mouseenter)="onShowSubItem(item)"
    (mouseleave)="onCloseSubItem(0, item)"
  >
    <div
      class="hover-item moon"
      [class.active]="theme === 'moon'"
      [class.deactive]="theme !== 'moon'"
      (click)="themeSwitchComponent.toggle(true)"
    >
      <!-- themeSwitchComponent.toggle(true) -->
      <i class="icon-moon"></i>
      <p class="text" *ngIf="!isH5">{{ 'night_m' | translate }}</p>
    </div>
    <app-theme-switch #themeSwitchComponent style="display: none"></app-theme-switch>
    <div
      class="hover-item sun"
      [class.active]="theme === 'sun'"
      [class.deactive]="theme !== 'sun'"
      (click)="themeSwitchComponent.toggle(false)"
    >
      <!-- themeSwitchComponent.toggle(false) -->
      <i class="icon-sun-rail"></i>
      <p class="text" *ngIf="!isH5">{{ 'day_m' | translate }}</p>
    </div>
    <div #moveBg [class]="theme === 'sun' ? 'move-bg-l' : 'move-bg-r'" [style.height]="height"></div>
  </div>
</ng-template>

<!-- 语言货币弹窗 -->
<ng-template #langCurrencyPupup>
  <div
    class="system-panel animate__animated animate__fill_none animate__mid_fast"
    [class]="leftMenuService.popupStatus ? 'animate__fadeInDown' : 'animate__fadeOutUp'"
  >
    <ng-container *ngIf="!isH5">
      <div class="panel-header">
        <ng-container *ngFor="let item of ['lang', 'view_in_f']; let index = index">
          <customize-button
            [class.active]="index === activePanelIndex"
            type="text-normal"
            size="large"
            (onClick)="activePanelIndex = index"
          >
            <span class="btn-text" [class.active]="index === activePanelIndex">{{ item | translate }}</span>
          </customize-button>
        </ng-container>
      </div>
      <div [class.panel-details]="activePanelIndex === 0" [class.panel-details-currency]="activePanelIndex === 1">
        <ng-container *ngIf="activePanelIndex === 0">
          <div
            class="select-btn"
            [class.active]="appService.languageCode === lang.code"
            *ngFor="let lang of allLangData"
            (click)="optionsSelect(lang.code)"
          >
            {{ lang.name }}
          </div>
        </ng-container>
        <ng-container *ngIf="activePanelIndex === 1">
          <!-- <div class="set-none">
            <div class="select-btn" [class.active]="!conversionCurrency?.enable" (click)="selectShowOnFiat(null)">
              <i class="icon-heart"></i>
              <p class="icon-text-1">None</p>
            </div>
          </div> -->
          <div class="currency">
            <div
              class="select-btn"
              [class.mr-2]="index === 0"
              [class.active]="
                conversionCurrency?.enable && conversionCurrency?.currency?.currency === currency.currency
              "
              *ngFor="let currency of faitCurrencies; let index = index"
              (click)="selectShowOnFiat(currency)"
            >
              <img class="icon-img" [src]="currency.icon" lazy="loading" />
              <p class="icon-text">
                <span class="icon-text-1">{{ currency.currency }}</span>
                <span class="icon-text-2">{{ currency.name }}</span>
              </p>
            </div>
          </div>
        </ng-container>
      </div>
    </ng-container>
    <ng-container *ngIf="isH5">
      <div class="h5-container">
        <div class="item" *ngFor="let item of ['lang', 'view_in_f']; let index = index">
          <div class="item-header">{{ item | translate }}</div>
          <div class="item-content">
            <app-scrollbar>
              <ng-container *ngIf="index === 0">
                <div
                  class="select-btn"
                  [class.active]="appService.languageCode === lang.code"
                  *ngFor="let lang of allLangData"
                  (click)="optionsSelect(lang.code)"
                >
                  {{ lang.name }}
                </div>
              </ng-container>
              <ng-container *ngIf="index === 1">
                <!-- <div class="select-btn" [class.active]="!conversionCurrency?.enable" (click)="selectShowOnFiat(null)">
                  <i class="icon-heart"></i>
                  <p class="icon-text-1">None</p>
                </div> -->
                <div
                  class="select-btn"
                  [class.mr-20]="index === 0"
                  [class.active]="
                    conversionCurrency?.enable && conversionCurrency?.currency?.currency === currency.currency
                  "
                  *ngFor="let currency of faitCurrencies; let index = index"
                  (click)="selectShowOnFiat(currency)"
                >
                  <img class="icon-img" [src]="currency.icon" lazy="loading" />
                  <p class="icon-text">
                    <span class="icon-text-1">{{ currency.currency }}</span>
                  </p>
                </div>
              </ng-container>
            </app-scrollbar>
          </div>
        </div>
      </div>
    </ng-container>
  </div>
</ng-template>

<!-- 【扩展时】菜单 item 模板 -->
<ng-template
  #menuItem
  let-item="item"
  let-icon="icon"
  let-canShowDropDown="canShowDropDown"
  let-mTop="mTop"
  let-raduis="raduis"
>
  <div [class]="raduis" *ngIf="!checkDisabled(item)">
    <a
      [href]="item.page ? domain + '/' + appService.languageCode + '/' + item.page : domain"
      (click)="$event.stopPropagation(); clickMenu(item, true); $event.preventDefault()"
    >
      <div
        [class]="['full-item', mTop]"
        [class.active]="isRouteActive(item?.page)"
        [class.disabled]="checkDisabled(item)"
        [class.expend-active]="item.expand || (!canShowDropDown && isRouteActive(item?.railPage))"
      >
        <ng-container *ngIf="isLeftMenuReady">
          <div class="full-unit">
            <ng-container *ngIf="icon?.startsWith('http'); else iconClassTemp">
              <img class="full-menu-image active-img" [src]="icon" lazy="loading" />
              <img class="full-menu-image inactive-img" [src]="item?.railColorIcon" lazy="loading" />
            </ng-container>
            <ng-template #iconClassTemp>
              <i class="full-icon" [class]="item.icon"></i>
            </ng-template>
            <p class="full-name">
              <ng-container *ngIf="item.ident === 'vip-club'">
                <span class="bold">VIP</span>
                <span class="primary-text">{{ 'club' | translate }}</span>
              </ng-container>
              <ng-container *ngIf="item.ident !== 'vip-club'">
                {{ item.name }}
              </ng-container>
            </p>
          </div>
          <ng-container *ngIf="item.ident === 'chat'">
            <span class="notice-number" *ngIf="chatService.unreadCount > 0">
              {{ chatService.unreadCount > 99 ? '99+' : chatService.unreadCount }}
            </span>
          </ng-container>
          <!-- 最新優惠 -->
          <ng-container *ngIf="item.ident === 'latest-offers'">
            <span class="notice-number" *ngIf="activityCount > 0">
              {{ activityCount > 99 ? '99+' : activityCount }}
            </span>
          </ng-container>
          <i class="icon-rightarrow" *ngIf="canShowDropDown" [class.arrow-down]="item.expand"></i>
        </ng-container>
        <ng-container *ngIf="!isLeftMenuReady">
          <p class="img-skeleton skeleton-loading"></p>
          <p class="text-skeleton skeleton-loading"></p>
        </ng-container>
      </div>
    </a>
    <ng-container *ngIf="canShowDropDown">
      <ng-container *ngTemplateOutlet="extensiveItem; context: { item: item }"></ng-container>
    </ng-container>
  </div>
</ng-template>

<!-- 扩展时 添加的下拉选项 -->
<ng-template #extensiveItem let-item="item">
  <div [@open]="item.expand">
    <div class="full-sub">
      <a
        *ngFor="let child of item.children"
        [href]="domain + '/' + appService.languageCode + '/' + child?.page"
        (click)="$event.stopPropagation(); clickMenu(child); $event.preventDefault()"
      >
        <div [class.border-line]="child?.ident == 'casino-favorites'">
          <div class="sub-unit" [class.active]="isRouteActive(child?.page)" [class.disabled]="checkDisabled(child)">
            <div style="display: flex; flex-direction: row">
              <ng-container *ngIf="isLeftMenuReady">
                <ng-container *ngIf="child?.menuIcon?.startsWith('http'); else iconClassTemp">
                  <img class="full-img" [class.filter-img]="isRouteActive(child?.page)" [src]="child.menuIcon" />
                  <!-- <img class="full-img active-img" [src]="child.icon" /> -->
                </ng-container>
                <ng-template #iconClassTemp>
                  <i class="full-icon" [class]="child.icon"></i>
                </ng-template>
                <p class="sub-name">{{ child.name }}</p>
              </ng-container>
              <ng-container *ngIf="!isLeftMenuReady">
                <p class="img-skeleton skeleton-loading"></p>
                <p class="text-skeleton skeleton-loading"></p>
              </ng-container>
            </div>
          </div>
        </div>
      </a>
    </div>
  </div>
</ng-template>

<!-- 展开时 推荐ID -->
<ng-template #extensiveReferralId>
  <div class="referral-id" (click)="openReferralId()">
    <div>
      <div class="ticket">
        <div class="img-wrap">
          <img src="assets/temp5/recommend-friend/gift.png" alt="" />
        </div>
        <div class="wrap">
          <span>{{ 'ref_id' | translate }}</span>
        </div>
      </div>
    </div>
    <div class="to-date">{{ 'ava_in_hour' | translate }}</div>
  </div>
</ng-template>

<!-- 展开时 语言和货币 -->
<ng-template #extensiveLangCurrencyTmp>
  <div class="lang-currency-switch" cdkOverlayOrigin #origin="cdkOverlayOrigin">
    <div class="language" [class.lang-only]="!menuReferenceSystems['conversionCurrency']" (click)="onSetSystem(0)">
      <ng-container *ngIf="isLeftMenuReady">
        <i class="icon-global"></i>
        <p class="text mlr-10">{{ currentLanugage?.name || '' }}</p>
        <i
          class="icon-downarrow"
          [class.active]="leftMenuService.popupStatus"
          [class.in-active]="!leftMenuService.popupStatus"
        ></i>
      </ng-container>
      <ng-container *ngIf="!isLeftMenuReady">
        <p class="text-skeleton skeleton-loading"></p>
      </ng-container>
    </div>
    <div class="currency" (click)="onSetSystem(1)" *ngIf="menuReferenceSystems['conversionCurrency'].showOnRail">
      <ng-container *ngIf="isLeftMenuReady">
        <p class="text symbol">{{ conversionCurrency?.currency?.symbol || '' }}</p>
        <p class="text mlr-10">
          {{ conversionCurrency?.currency?.currency || 'None' }}
        </p>
        <i
          class="icon-downarrow"
          [class.active]="leftMenuService.popupStatus"
          [class.in-active]="!leftMenuService.popupStatus"
        ></i>
      </ng-container>
      <ng-container *ngIf="!isLeftMenuReady">
        <p class="text-skeleton skeleton-loading"></p>
      </ng-container>
    </div>
    <ng-container *ngIf="isH5">
      <ng-container
        *ngTemplateOutlet="themeSwitch; context: { theme: appService.themeSwitch$ | async, height: '4rem' }"
      ></ng-container>
    </ng-container>
    <ng-template
      cdkConnectedOverlay
      [cdkConnectedOverlayOrigin]="origin"
      [cdkConnectedOverlayPositions]="popupPosition"
      [cdkConnectedOverlayOpen]="leftMenuService.popupStatus"
    >
      <ng-container [ngTemplateOutlet]="langCurrencyPupup"></ng-container>
    </ng-template>
  </div>
</ng-template>

<!-- 展开和H5模式 -->
<ng-template #leftExpandMenu>
  <div class="full-menu-list">
    <ng-container *ngFor="let item of menuData.top">
      <ng-container
        *ngTemplateOutlet="menuItem; context: { item: item, mTop: 'm-top', raduis: 'border-radius' }"
      ></ng-container>
    </ng-container>
  </div>

  <div class="full-menu-list">
    <ng-container *ngFor="let item of menuData.list">
      <ng-container
        *ngTemplateOutlet="
          menuItem;
          context: {
            item: item,
            mTop: 'm-top',
            icon: item?.railIcon || '',
            canShowDropDown: item?.canShowDropDown,
            raduis: 'border-radius',
          }
        "
      ></ng-container>
    </ng-container>
  </div>
  <div class="full-menu-list">
    <ng-container *ngFor="let item of menuData.options">
      <ng-container
        *ngTemplateOutlet="menuItem; context: { item: item, mTop: 'm-top', raduis: 'border-radius' }"
      ></ng-container>
    </ng-container>
  </div>
  <!-- Hidden due to ALL-11624 -->
  <!-- <div class="full-menu-list" *ngIf="showBindReferralId">
    <ng-container *ngFor="let item of menuData.referralId">
      <ng-container
        *ngTemplateOutlet="extensiveReferralId; context: { item: item, mTop: 'm-top', raduis: 'border-radius' }"
      ></ng-container>
    </ng-container>
  </div> -->

  <!-- 活动入口 -->
  <!-- Hidden due to ALL-11624 -->
  <!-- <div class="full-menu-list">
    <app-left-menu-activity-bar
      (afterClick)="turn(false)"
      [showFully]="true"
      [showRail]="false"
      [onlyShowInvite]="true"
      [showInviteCodeModel]="isShowInviteCodeModel"
    ></app-left-menu-activity-bar>
  </div> -->

  <div class="full-menu-list">
    <ng-container *ngFor="let item of menuData.supports">
      <ng-container *ngIf="item.ident === 'chat' ? chatService.chatEnabled : true">
        <ng-container
          *ngTemplateOutlet="menuItem; context: { item: item, mTop: 'm-top', raduis: 'border-radius' }"
        ></ng-container>
      </ng-container>
    </ng-container>
  </div>
  <div class="full-menu-list">
    <ng-container *ngTemplateOutlet="extensiveLangCurrencyTmp"></ng-container>
  </div>

  <div class="full-menu-list" *ngIf="!isH5">
    <ng-container
      *ngTemplateOutlet="themeSwitch; context: { theme: appService.themeSwitch$ | async, height: '4.8rem' }"
    ></ng-container>
  </div>
</ng-template>
